"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const layouts_1 = __importDefault(require("../layouts"));
const ContactForm_1 = __importDefault(require("../components/contact/ContactForm"));
var ContactPage = function ContactPage() {
    return /*#__PURE__*/ react_1.default.createElement(layouts_1.default, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("h1", null, "Contact"), /*#__PURE__*/ react_1.default.createElement(ContactForm_1.default, null))));
};
exports.default = ContactPage;
